<template>
	<div v-if="show" class="dynamic-mobile-cta" data-testid="dynamic-mobile-cta">
		<a
			v-adobe-data-layer="ctaADLConfig"
			class="btn btn-dark btn-icon text-nowrap"
			:href="ctaLink"
			data-testid="cta-btn"
		>
			{{ ctaText }}

			<svg class="ki" width="16" height="16" fill="currentColor">
				<use href="/etc/designs/ltnext/lt-kumiko-components/icons/kumiko-icons.svg#arrow-out"></use>
			</svg>
		</a>
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { prerenderGateCheck } from '@/util/prerenderGateCheck';
import { logError } from '@/util/logger';
import vAdobeDataLayer from '@/directives/AdobeDataLayer';

const DEFAULT_CTA_TEXT = 'OPEN IN LIFE TIME APP';

const href = ref('');
const ctaText = ref(DEFAULT_CTA_TEXT);

onMounted(() => {
	if (prerenderGateCheck()) {
		return;
	}

	const params = new URLSearchParams(window.location.search);
	href.value = window.location.href;
	ctaText.value = params.get('text') ?? DEFAULT_CTA_TEXT;
});

const encodeUrl = (url: string) => {
	// btoa only supports Latin1, so percent-encode any UTF-8 characters first.
	const latin1Safe = encodeURIComponent(url).replace(/%([0-9A-F]{2})/g, (_, hex) =>
		String.fromCharCode(parseInt(hex, 16))
	);

	return btoa(latin1Safe);
};

const ctaLink = computed(() => {
	if (!href.value) {
		return '';
	}

	try {
		return `lifetime-member://applink?link=${encodeUrl(href.value)}`;
	} catch (error) {
		logError('Dynamic Mobile CTA - failed to encode URL', { href: href.value }, error);
		return '';
	}
});

const show = computed(() => !!ctaLink.value);

const ctaADLConfig = computed(() => ({
	name: 'dynamicmobilecta',
	type: 'button',
	title: ctaText.value,
	link: ctaLink.value
}));

defineExpose({
	ctaLink,
	ctaText,
	show
});
</script>
